import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";
import * as pageActions from "../pages/actions";

export function fetchPlace(payload) {
  return { type: actionTypes.FETCH_PLACE, payload };
}
export function fetchPlaceSuccess(payload) {
  const id = payload.places.placeUid
  const byId = { [id]: payload.places };
  return { type: actionTypes.FETCH_PLACE_SUCCESS, payload: { byId } };
}
export function fetchPlaces(payload) {
  return { type: actionTypes.FETCH_PLACES, payload };
}
export function fetchPlacesSuccess(payload) {
  const byId = keyBy(payload[0].places, (place) => place.placeUid);
  return {
    type: actionTypes.FETCH_PLACES_SUCCESS,
    payload: { byId , "places": payload[0].places, "placesDropList": payload[0].placesDropList },
  };
}
export function savePlace(payload) {
  return { type: actionTypes.SAVE_PLACE, payload };
}
export function savePlaceSuccess(payload) {
  return { type: actionTypes.SAVE_PLACE_SUCCESS, payload };
}
export function updatePlace(payload) {
  return { type: actionTypes.UPDATE_PLACE, payload };
}
export function updatePlaceSuccess(payload) {
  return { type: actionTypes.UPDATE_PLACE_SUCCESS, payload };
}
export function deletePlace(payload) {
  return { type: actionTypes.DELETE_PLACE, payload };
}

export function deletePlaceSuccess(payload) {
  return { type: actionTypes.DELETE_PLACE_SUCCESS, payload };
}
